// Lead phone helpers with NO phone library (CU-869fnwgxf), so the lead page and
// the dialer can use them without pulling libphonenumber-js into their chunks.
// The form-side check itself lives in ./phoneCheck.js.

export const STRICT_PHONE_PARAM = 'phone_check=strict';

// Append ?phone_check=strict: the backend then refuses a CHANGED number the desk
// phone can't dial (400 on lead_contact.phone). Only CRM create/edit screens send it.
export const withStrictPhoneCheck = (url) => `${url}${url.includes('?') ? '&' : '?'}${STRICT_PHONE_PARAM}`;

// The backend's phone_check / number_check: { ok, reason, message } or null.
// Returns the message when the number can't be dialled, else ''.
export const phoneProblem = (check) => (check && check.ok === false && check.message ? String(check.message) : '');

// The badge text on the lead page.
export const PHONE_BADGE_TEXT = 'Number looks wrong — check with patient';

// A 400 from a strict save: the plain phone message, or '' if the error is about something else.
export const phoneSaveError = (response) => {
    const phone = response?.status === 400 ? response?.data?.lead_contact?.phone : null;
    const first = Array.isArray(phone) ? phone[0] : phone;
    return typeof first === 'string' ? first : '';
};
